import { CommentAttributor } from './Comment';

class Reaction extends CommentAttributor {
  constructor(attrName = 'reaction', keyName = 'reaction') {
    super(attrName, keyName);
  }
}

export default new Reaction();
